import { render } from "./Coin.vue?vue&type=template&id=75b37fff&scoped=true"
import script from "./Coin.vue?vue&type=script&lang=js"
export * from "./Coin.vue?vue&type=script&lang=js"

import "./Coin.vue?vue&type=style&index=0&id=75b37fff&scoped=true&lang=css"

import exportComponent from "D:\\work\\application\\棋牌游戏5.0\\chesscards_5.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75b37fff"]])

export default __exports__